import './style/general.css';
import ForgeInfo from './components/ForgeInfo';
import Header from './components/Header';
import Tabs from './components/Tabs';
import Profile from './components/Profile';
import OSSContribution from './components/OSSContribution';
import CardList from './components/CardList';
import Project from './components/Project';
import data from './data.json'

function App() {
    return (
        <>
            <Header />
            <div style={styles.container}>
                <Profile name="Clément Mathieu--Drif"
                    location="Grenoble area, France"
                    profilePicture="/images/profile.png"
                    linkedin={{url: "https://www.linkedin.com/in/cmathieudrif", short: "cmathieudrif"}} />
                <Tabs>
                    <Tabs.Tab name='Version Control'>
                        <CardList>
                            {data.accounts.map(account => (
                                <ForgeInfo key={account.url} {...account} />
                            ))}
                        </CardList>
                    </Tabs.Tab>
                    <Tabs.Tab name='OSS contributions'>
                        <CardList>
                            {data.contributions.map(contribution => (
                                <OSSContribution key={contribution.platform} {...contribution} />
                            ))}
                        </CardList>
                    </Tabs.Tab>
                    <Tabs.Tab name={'Projects'}>
                        <CardList>
                            {data.projects.map(project => (
                                <Project key={project.name} {...project} />
                            ))}
                        </CardList>
                    </Tabs.Tab>
                </Tabs>
            </div>
        </>
    );
}

const styles = {
    container: {
        marginTop: '2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        paddingTop: '2rem',
        paddingBottom: '3rem',
        paddingLeft: '0',
        paddingRight: '0',
        overflowX: 'hidden'
    },
    forgeList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2rem',
        marginLeft: 'auto',
        marginRight: 'auto',
        alignItems: 'center',
        width: '100%'
    },
};

export default App;
